import { formatToTime } from "./FormatToDateTime";
import { formatDate } from "./Master";

export const printAttendanceReport = (staffs, selectedMonth, totalDays) => {
  if (!staffs?.length) return;

  const rows = staffs
    .map((staff, index) => {
      let totalPresent = 0;
      let totalAbsent = 0;

      let workingDays = [];

      try {
        workingDays = JSON.parse(staff?.employment_info?.working_days || "[]");
      } catch {}

      let dayColumns = "";

      for (let i = 1; i <= totalDays; i++) {
        const day = String(i).padStart(2, "0");
        const currentDate = `${selectedMonth}-${day}`;

        const attendances =
          staff.attendances?.filter((a) => a.date === currentDate) || [];

        const checkDate = new Date(currentDate);

        const today = new Date();

        const isFuture = checkDate > today;

        const weekday = checkDate.toLocaleDateString("en-US", {
          weekday: "short",
        });

        const isWorking = workingDays.includes(weekday);

        let value = "-";

        if (isFuture) {
          value = "";
        } else if (attendances.length) {
          if (attendances.some((a) => a.is_leave === "1")) {
            value = "A";
            totalAbsent++;
          } else {
            value = "P";
            totalPresent++;
          }
        } else if (!isWorking) {
          value = weekday === "Sun" ? "SUN" : "OFF";
        } else {
          value = "-";
        }

        dayColumns += `<td>${value}</td>`;
      }

      return `
<tr>

<td>${index + 1}</td>

<td style="text-align:left">

<b>${staff.name}</b>

<br>

${staff.registration_no}

</td>

${dayColumns}

<td>${totalPresent}</td>

<td>${totalAbsent}</td>

</tr>
`;
    })
    .join("");

  const headers = Array.from(
    { length: totalDays },
    (_, i) => `<th>${i + 1}</th>`,
  ).join("");

  const printWindow = window.open("", "_blank");

  printWindow.document.write(`
<html>

<head>

<title>Monthly Staff Attendance</title>

<style>

@page{

size:A3 landscape;

margin:8mm;

}

body{

font-family:Arial;

font-size:10px;

margin:0;

padding:10px;

}

h2{

text-align:center;

margin-bottom:5px;

}

h4{

text-align:center;

margin-top:0;

margin-bottom:15px;

}

table{

width:100%;

border-collapse:collapse;

}

th,
td{

border:1px solid #000;

padding:4px;

text-align:center;

white-space:nowrap;

}

th{

background:#efefef;

}

</style>

</head>

<body>

<h2>Monthly Staff Attendance Register</h2>

<h4>${formatDate(selectedMonth + "-01")}</h4>

<table>

<thead>

<tr>

<th>SN</th>

<th>Name</th>

${headers}

<th>P</th>

<th>A</th>

</tr>

</thead>

<tbody>

${rows}

</tbody>

</table>

<script>

window.onload=function(){

window.print();

window.onafterprint=function(){

window.close();

}

}

</script>

</body>

</html>
`);

  printWindow.document.close();
};
